import { z } from "zod";

/**
 * Contratos de gestión de la estructura académica del tenant (ADR 055). El ADMIN
 * crea facultades, y dentro de ellas escuelas (EAPs). El `institucionId` NUNCA
 * viaja en el body: lo deriva el backend del usuario autenticado, así un ADMIN
 * sólo toca SU institución. Los códigos son únicos POR institución.
 *
 * ADR 055 (enmienda): se eliminó el Departamento Académico — los docentes se
 * afilian a EAPs (escuelas), no a departamentos.
 */

const nombreAcademico = z.string().trim().min(3, "Mínimo 3 caracteres").max(160);
const codigoAcademico = z
  .string()
  .trim()
  .min(1)
  .max(20)
  .regex(/^[A-Za-z0-9-]+$/, "Solo letras, dígitos y guiones")
  .transform((s) => s.toUpperCase());

export const crearFacultadSchema = z.object({
  nombre: nombreAcademico,
  codigo: codigoAcademico,
});
export type CrearFacultadInput = z.infer<typeof crearFacultadSchema>;

export const crearEscuelaSchema = z.object({
  nombre: nombreAcademico,
  codigo: codigoAcademico,
  facultadId: z.string().uuid(),
});
export type CrearEscuelaInput = z.infer<typeof crearEscuelaSchema>;
